import { AbstractJSONModel } from "./master-model";
export interface IUserActivation {
  id: number;
  token: string;
  inst_code: number;
  email: string;
  full_name: string;
  postal_code: string;
  expires: string;
  state: number;
  dtp_user_created_at: Date | null;
  ssn: string;
  created_at: string;
  updated_at: string;
  user_id: number;
}

export class UserActivation extends AbstractJSONModel implements IUserActivation {
  public id = -1;
  public token = "";
  public inst_code = -1;
  public email = "";
  public full_name = "";
  public postal_code = "";
  public expires = "";
  public state = -1;
  public dtp_user_created_at = null;
  public ssn = "";
  public created_at = "";
  public updated_at = "";
  public user_id = -1;
}
